import { render } from "./AddRacer.vue?vue&type=template&id=430fcf84&scoped=true"
import script from "./AddRacer.vue?vue&type=script&lang=js"
export * from "./AddRacer.vue?vue&type=script&lang=js"

import "./AddRacer.vue?vue&type=style&index=0&id=430fcf84&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-430fcf84"]])

export default __exports__